import { Grid, Box } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import icon from '../Assets/404_icon.png';
import GenButton from './GenButton';
import GenDataText from './GenDataText';

const Error404 = ({ click }) => {
  const { t } = useTranslation('global');
  return (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      sx={{ height: 'calc(100vh - 470px)', px: 1 }}
    >
      <Grid item>
        <Grid container flexDirection="column" alignItems="center">
          <Grid item>
            <Box
              component="img"
              src={icon}
              sx={{
                maxWidth: { xs: '72px', sm: '162px', lg: '232px' },
                maxHeight: { xs: '72px', sm: '162px', lg: '232px' },
              }}
            />
          </Grid>
          <Grid item sx={{ mb: 1, textAlign: 'center' }}>
            <GenDataText
              text={t('errors.404.title')}
              textColor="textPrimary"
              textVariant="H6"
            />
          </Grid>
          <Grid item sx={{ mb: 4, textAlign: 'center' }}>
            <GenDataText
              text={t('errors.404.subtitle')}
              textVariant="body1"
              direction="vertical"
            />
          </Grid>
          <Grid item>
            <GenButton
              size="large"
              variant="contained"
              color="primary"
              text={t('errors.404.button')}
              onClick={click}
            />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Error404;
